import { TScheduleGroup, TScheduleService } from '../schedule';

export const SCHEDULE_GROUPS: Array<{ key: TScheduleGroup; label: string }> = [
  { key: 'Planning', label: 'schedulesPage.groups.Planning' },
  { key: 'Export', label: 'schedulesPage.groups.Export' },
  { key: 'Import', label: 'schedulesPage.groups.Import' }
];
export const SCHEDULE_SERVICES: Array<{ key: TScheduleService; label: string }> = [
  { key: 'PlanningCalculation', label: 'schedulesPage.services.PlanningCalculation' },
  { key: 'OrderExport', label: 'schedulesPage.services.OrderExport' },
  { key: 'ImportConnector', label: 'schedulesPage.services.ImportConnector' },
  { key: 'LambdaRunner', label: 'schedulesPage.services.LambdaRunner'}
];
